export const colors = {
    PRIMARY: "#FB6910",
    SECONDARY: "#343233",
    TERTIARY: "#E8E8E8",
    BACKGROUND: "#FFFFFF",
    BACKGROUND2: "#F6F6F7",
    RED: "#E72424",
    GREEN: "#15b138"
}